import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface Product {
  id: number;
  name: string;
  category: string;
  price: string;
  oldPrice: string;
  rating: number;
  stock: boolean;
  image: string;
  description: string;
}

export interface ClassItem {
  id: number;
  title: string;
  description: string;
  icon: string;
  level: string;
  duration: string;
  coach: string;
  rating: number;
  students: number;
  price: string;
  color: string;
  image: string;
  tags: string[];
}

export interface Trainer {
  id: number;
  name: string;
  role: string;
  experience: string;
  certifications: string[];
  bio: string;
  rating: number;
  students: number;
  image: string;
  icon: string;
  color: string;
  textColor: string;
}

export interface GalleryImage {
  id: number;
  src: string;
  category: string;
  title: string;
  description: string;
}

@Injectable({ providedIn: 'root' })
export class ApiService {
  private apiUrl = 'http://localhost:3000/api';

  constructor(private http: HttpClient) {}

  getProducts(page: number = 1, limit: number = 15, category?: string, search?: string): Observable<any> {
    let url = `${this.apiUrl}/products?page=${page}&limit=${limit}`;
    if (category && category !== 'all') url += `&category=${category}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    return this.http.get<any>(url);
  }

  getClasses(): Observable<ClassItem[]> {
    return this.http.get<ClassItem[]>(`${this.apiUrl}/classes`);
  }

  getTrainers(): Observable<Trainer[]> {
    return this.http.get<Trainer[]>(`${this.apiUrl}/trainers`);
  }

  getGallery(category?: string): Observable<GalleryImage[]> {
    let url = `${this.apiUrl}/gallery`;
    if (category && category !== 'all') url += `?category=${category}`;
    return this.http.get<GalleryImage[]>(url);
  }

  contactSubmit(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/contact`, data);
  }
}
